export class CommonUtils {

    // returns true if value is null or undefined
    public static isNil(value: any): boolean {
        if(typeof value==='string') return value.length===0;
        if(Array.isArray(value)) return value.length===0;
        return (value == undefined) || (value == null);
    }

    public static isNotNil(value: any): boolean {
        if(typeof value === 'string') return value.length !== 0;
        return (value != undefined) || (value != null);
    }

    // to check if it is empty, useful for only ''/[]/{}/undefined/null, wont work for 123 because its not a collection
    public static isEmpty(value: any): boolean {
        return value == undefined || value == null || !(Object.keys(value) || value).length;
    }

    // use to check the type, if its string and will return the value, param = string
    public static isString(value: any): boolean {
        return typeof value === 'string';
    }

    public static isNotString(value: any): boolean {
        return typeof value !== 'string';
    }

    // Get size of arrays, objects or strings.
    public static size(value: any): number{ // param = array, object, string
        return Array.isArray(value)
        ? value.length
        : value && typeof value === "object"
        ? value.size || value.length || Object.keys(value).length
        : typeof value === "string"
        ? new Blob([value]).size
        : 0;
    }

    public static sortBy(arr: any, key: any, isDesc?: boolean) {
        if(isDesc) {
            return arr.sort((a, b) => (a[key] < b[key] ? 1 : a[key] > b[key] ? -1 : 0));   
        }
        return arr.sort((a, b) => (a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0));
    }

    // Performs a deep comparison between two values to determine if they are equivalent.
    public static areValuesEquals(a: any, b: any): boolean {
        if (a === b) return true;
        if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b;
        if (a === null || a === undefined || b === null || b === undefined) return false;
        if (a.prototype !== b.prototype) return false;
        let keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) return false;
        return keys.every(k => CommonUtils.areValuesEquals(a[k], b[k]));
    }

    // Recursively flattens array. []
    public static flattenDeep(arr: any) {
        return Array.isArray(arr)
        ? arr.reduce((a, b) => a.concat(CommonUtils.flattenDeep(b)) , [])
        : [arr];
    }

    // Creates an object composed of the object properties predicate returns truthy for.
    public static pick(obj: any, keys: any) { // param - object and key in array
        return keys.reduce((object, key) => {
            if(obj && obj.hasOwnProperty(key)) {
                object[key] = obj[key];
            }
            return object;
        }, {});
    }

    public static isFalse(value: boolean | string): boolean {
        return value === undefined || value === null || value === false || String(value).toLowerCase() === 'false';
    }
   
    public static isTrue(value: boolean|string): boolean {
        if(value===undefined||value===null) return false;
        return value===true || String(value).toLowerCase() === 'true';
    }

    // to check whether its of number type and handle the cases - (-/+Infinite),NaN, '123456', 'A123456', 123456
    public static isNumber(value: any): boolean {
        const num: number = Number(value);
        const isTypeNumber = typeof num === 'number';
        const isFiniteNumber = Number.isFinite(num);
        return isTypeNumber && isFiniteNumber;
    }


    public static isSame(data: string,matchedData:string) {
        return data!=null && matchedData!=null && data.toUpperCase()===matchedData.toUpperCase();
    }

    public static getData(data) {
        return this.isNotNil(data)? data:'';
    }

    public static trimSpaces(val: string) {
        // let trimmedVal: string = val.trim();
        // let normalString: string = trimmedVal.replace(/\s+/g, ' ');
        // return normalString;
        return val.trim().replace(/\s+/g, ' ');
    }

}